
/**
 * Return boolean indicating if element is overflown
 * @param {HTMLElement} element - HTML element to check
 * @returns {boolean}
 */
function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

function init() {
  addShowHideButtonListeners();
  addEventListener('resize', updateShowHideButtonVisibility);
  updateShowHideButtonVisibility();  
}

/**
 * Add click listener to show-hide overflow buttons
 */
function addShowHideButtonListeners() {
  const btns = document.querySelectorAll('button.seo-content__btn-show-hide');
  for (const btn of btns) {
    btn.addEventListener("click", function(event) {
      const textContent = event.currentTarget.parentNode.querySelector('div.seo-content__text');
      textContent.classList.toggle('hide-overflow');
      btn.classList.toggle('active');
      if (!btn.classList.contains('active')) {
        isOverflown(textContent) ? btn.style.display = 'inline-flex' : btn.style.display = 'none';
      }            
    });
  }
}

function updateShowHideButtonVisibility() {
  const btns = document.querySelectorAll('button.seo-content__btn-show-hide');
  for (const btn of btns) {
    const textContent = btn.parentNode.querySelector('div.seo-content__text');
    const columnCount = window.getComputedStyle(textContent).columnCount;
    if (columnCount === '2') { // desktop mode
      btn.style.display = 'none';
      return;
    }
    if (btn.classList.contains('active')) { // hidden content already expanded
      btn.style.display = 'inline-flex';
      return;
    }
    isOverflown(textContent) ? btn.style.display = 'inline-flex' : btn.style.display = 'none';
  }
}

export default { init };
export { init };
